<div class="item-info">
  <mat-icon [svgIcon]="itemIcon" class="icon"></mat-icon>
  <div class="item-title">{{ title }}</div>
</div>
<div class="item-additional-info">
  <ng-content></ng-content>
</div>
